module.exports = __webpack_public_path__ + "static/media/troquetas-apresentacao.97c682e9.svg";